import { useEffect, useRef, useState } from 'react'

import styled from 'styled-components'

import { BuildingProvider } from '../../contexts/buildingContext'
import { useUserContext } from '../../contexts/userContext'
import { media } from '../../styles/breakpoints'

import { NotificationHub } from './Notifications/NotificationHub'
import { UserMenu } from './UserMenu'

const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: relative;
  background: #073c7a;
  color: #fff;
  display: table-cell;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
`

export const UserBlock = () => {
  const [userInitials, setUserInitials] = useState('')
  const [menuOpen, setMenuOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)
  const user = useUserContext().state

  const getUserInitials = () => {
    if (user.first_name && user.last_name) {
      return (
        user.first_name.substring(0, 1).toUpperCase() +
        user.last_name.substring(0, 1).toUpperCase()
      )
    } else {
      return user.email.substring(0, 2)
    }
  }

  useEffect(() => {
    if (user.isAuthenticated) setUserInitials(getUserInitials())
    // eslint-disable-next-line
  }, [user])

  if (!user.isAuthenticated) return <></>

  return (
    <UserBlockContainer ref={anchorRef}>
      <NotificationHub />
      <Avatar onClick={() => setMenuOpen(!menuOpen)}>{userInitials}</Avatar>
      <BuildingProvider>
        <UserMenu
          display={menuOpen}
          setDisplay={setMenuOpen}
          anchorRef={anchorRef}
        />
      </BuildingProvider>
    </UserBlockContainer>
  )
}

const UserBlockContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 1100;

  @media ${media.belowTablet} {
    gap: 4px;
  }
`
